import { TYPOGRAPHY_COLORS } from 'constants/TypographyColors'
import { SVGIcon } from './SvgIcon/SvgIcon'
import { IconProps } from './types'

export const ChevronIcon = ({
  size,
  color = 'blackMaster',
  rotate = 0,
  className,
}: IconProps) => (
  <SVGIcon
    size={size}
    color={color}
    viewBox="0 0 16 16"
    rotate={rotate}
    className={className}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={TYPOGRAPHY_COLORS[color]}
    >
      <path
        d="M12 6.5L8 10.5L4 6.5"
        stroke={TYPOGRAPHY_COLORS[color]}
        strokeWidth="1.4"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGIcon>
)
